import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import {
  payloadWalletIdentities,
  WalletItemType,
} from "../../store/agent/agents";

const getWallets = () => {
  const endpoint = api.cashier.wallets.list;

  return fetch(
    `${endpoint}`,
    {...RequestOptions('GET')}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getWalletIdentities = (data: payloadWalletIdentities) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = `${api.agent.agentList.walletIdentities.replace('{agentId}', `${data.agentId}`)}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`;

  return fetch(`${endpoint}`, {...RequestOptions('GET')})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const enableWallet = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.enableWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const disableWallet = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.disableWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const addWallet = (data: WalletItemType) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.agent.agentList.addWallet;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getBalanceByWalletIdentities = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.cashier.wallets.updateBalance;

  const payload = {
    ...data.payload,
    authenticity_token: authenticity_token,
  }

  return fetch(
    `${endpoint}`,
    {...RequestOptions('POST', JSON.stringify(payload))}
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

export const walletsService = {
  getWallets,
  enableWallet,
  disableWallet,
  addWallet,
  getWalletIdentities,
  getBalanceByWalletIdentities,
};
